import { Group, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

type WarnRowProps = {
  label: string;
  value: string | number;
  warn: boolean;
  hint: string;
};

export function WarnRow({ label, value, warn, hint }: WarnRowProps) {
  return (
    <Group justify="space-between" align="flex-start">
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Stack gap={2} align="flex-end">
        {warn ? (
          <>
            <Group gap="xs">
              <IconAlertTriangle size={16} color="orange" />
              <Text size="sm" c="orange">
                {value}
              </Text>
            </Group>
            <Text size="xs" c="dimmed">
              {hint}
            </Text>
          </>
        ) : (
          <Text size="sm">{value}</Text>
        )}
      </Stack>
    </Group>
  );
}
